import { render, staticRenderFns } from "./PromotionList.vue?vue&type=template&id=629f08b0&scoped=true&"
import script from "./PromotionList.vue?vue&type=script&lang=js&"
export * from "./PromotionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629f08b0",
  null
  
)

export default component.exports